import { Link } from 'react-router-dom';

const links = [
  {
    title: 'Развитие персонала',
    desc: 'Хаб кластера: системный подход к развитию сотрудников и компетенций.',
    to: '/razvitie-personala',
  },
  {
    title: 'Корпоративное обучение',
    desc: 'Главный хаб: форматы, подходы и инструменты корпоративного обучения.',
    to: '/enciklopediya-korporativnogo-obucheniya',
  },
  {
    title: 'Корпоративная академия',
    desc: 'Если компании требуется системное развитие сотрудников на постоянной основе.',
    to: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya',
  },
  {
    title: 'Адаптация сотрудников',
    desc: 'Если оценка используется в процессе ввода новых сотрудников в должность.',
    to: '/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov',
  },
  {
    title: 'Менеджмент и лидерство',
    desc: 'Если речь идёт о развитии управленческих компетенций и подготовке руководителей.',
    to: '/menedzhment-i-liderstvo',
  },
  {
    title: 'Обучение отдела продаж',
    desc: 'Если оцениваются сотрудники отдела продаж и их навыки коммуникации с клиентами.',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh',
  },
];

export default function RelatedClusters() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Связь с другими направлениями
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Оценка сотрудников связана с другими направлениями развития — в зависимости от того, какую задачу решает компания.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {links.map((item, i) => (
            <Link
              key={i}
              to={item.to}
              className="bg-gray-50 rounded-xl border border-gray-100 p-5 md:p-6 hover:border-teal-300 hover:shadow-lg transition-all group cursor-pointer"
            >
              <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">{item.desc}</p>
              <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-600 group-hover:text-teal-700 transition-colors">
                Подробнее
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}